import React, { useState } from 'react'
import styled from 'styled-components'
import Button from '../../atoms/Button/Button'
import phonePurple from '../../../images/icon-phone-purple.svg'
import iconEnvelopePurple from '../../../images/icon-envelope-purple.svg'
import whiteEnvelope from '../../../images/icon-envelope-white.svg'
import media from 'styled-media-query'
import iconPhoneWhite from '../../../images/icon-phone-white.svg'
import Modal from '../CenterCards/Modal'
import useInsights from '../../../hooks/algolia/useInsights'
import {
  shouldDisplayVerifyInsurance,
  shouldDisplayVerificationOfBenefits
} from '../../../domain/useCases/contactBarDisplay'
import ContentModal from '../../molecules/ContentModal/ContentModal'
import useSegment from '../../../hooks/segment/useSegment'
import { createDataLayerIfNotExists } from '../../../utils/global/createDataLayerIfNotExists'
import useDidMount from '../../../hooks/useDidMount'
import VoBForm from '../../forms/VoBForm'
import { delayBy } from '../../../utils/delayBy'
import appendUtmSourceAndMediumToUrl from '../../../domain/appendUtmSourceAndMediumToUrl'
import { isNil, isEmptyString } from '../../../utils/checks'
import { getCenterProfileSlug } from '../../../domain/center'

const Style = styled.div`
  transition: height 0.3s;
  width: 100%;
  height: 0px;
  background: white;
  position: fixed;
  bottom: 0;
  z-index: 30;
  justify-content: space-around;
  border-top: 1px solid white;
  ${media.greaterThan('medium')`
    display: none;
  `}
  button {
    ${media.lessThan('medium')`
  font-size: 14px;
  `}
  }

  button {
    height: 45px;
    padding: 0;
    width: 100%;
    margin-top: 16px;
    padding: 12px 10px;
    text-decoration: none;
    font-weight: 800;
  }
  .email-btn {
    background: #efefef;
    color: black;
    font-weight: 800;
  }
  a {
    text-decoration: none;
  }

  &.stuck {
    height: 77px;
    transition: height 0.3s;
    display: block;
    opacity: 1;
    border: solid 1px #e4e4e4;
    background: #ffffff;
    box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.12);

    ${media.greaterThan('large')`
        display: none;
    `}
  }
`

const segment = useSegment()

// the below code pertains to Google Tag Manager and may have no context outside of this file; DO NOT DELETE.
const handleDataLayerStickyBarPhoneNumberClick = (props) => {
  segment.ui.callCta({
    ...props.phone,
    center_slug: getCenterProfileSlug(props.data)
  })
  createDataLayerIfNotExists()
  window.dataLayer.push({ ecommerce: null })
  window.dataLayer.push({
    event: 'purchase',
    ecommerce: {
      items: [
        {
          item_name: props.data.title,
          item_id: props.data.slug,
          item_variant: props.data.listing_template,
          item_category: 'Sticky Footer Phone Number'
        }
      ]
    }
  })
}

const ContactBar = (props) => {
  const didMount = useDidMount()
  const [modal, setModal] = useState(false)
  const { userID, recordAlgoliaConversion } = useInsights()
  const [isBenefitsModalOpen, setIsBenefitsModalOpen] = useState(false)
  const [shouldDisplayVerifyBenefits] = useState(
    shouldDisplayVerificationOfBenefits(props?.data?.benefitsProvider) || false
  )
  const [displayVerifyInsurance] = useState(
    shouldDisplayVerifyInsurance(props?.data?.verify_insurance_link, {
      benefitsKey: props?.data?.benefitsKey,
      benefitsProvider: props?.data?.benefitsProvider
    }) || false
  )

  const toggleModal = () => {
    setModal(!modal)
    if (document) {
      document.querySelector('html').style.overflow = modal ? null : 'hidden'
    }
  }

  const handleDataLayerInquiryClick = (data) => {
    createDataLayerIfNotExists()
    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: 'Inquiry click',
      ecommerce: {
        items: [
          {
            item_name: data.title,
            item_id: data.slug,
            item_variant: data.listing_template,
            item_category: 'Inquiry Form Modal Click'
          }
        ]
      }
    })
  }

  let urlParams
  let urlParamsObj = {}
  const closeBenefitsModal = () => {
    setIsBenefitsModalOpen(false)
  }

  const openBenefitsModal = async () => {
    await delayBy(500)(setIsBenefitsModalOpen(true))
    segment.verifyBenefits.opened({ triggeredBy: 'Contact Bar CTA' })
  }

  if (didMount) {
    urlParams = new URLSearchParams(window.location.search)
    for (const [key, value] of urlParams) {
      urlParamsObj[key] = value
    }
  }

  return (
    <React.Fragment>
      <Style
        id="sticky-footer"
        className="stuck"
      >
        <div className="flex gap-4 px-4">
          {props.data.primary_cta === 'call' && displayVerifyInsurance ? (
            <>
              {shouldDisplayVerifyBenefits ? (
                <button
                  className="verify-benefits flex h-[42px] w-[147px] flex-row items-center justify-center whitespace-nowrap rounded-md bg-gray-200 px-3 py-2 text-black"
                  onClick={openBenefitsModal}
                >
                  Verify Insurance
                </button>
              ) : (
                <Button
                  className="email-btn"
                  flex
                >
                  <a
                    href={appendUtmSourceAndMediumToUrl(
                      props.data.verify_insurance_link
                    )}
                    className="verify"
                    target="_blank"
                    style={{
                      display: 'flex',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      color: 'black'
                    }}
                    rel="noreferrer"
                    onClick={() => {
                      segment.verifyBenefits.externalLink({
                        href: props.data.verify_insurance_link
                      })
                    }}
                  >
                    Verify Insurance
                  </a>
                </Button>
              )}
              <Button className="sticky-footer-call">
                <a
                  className="flex items-center justify-center text-white"
                  id="phone-number-click"
                  onClick={() => {
                    handleDataLayerStickyBarPhoneNumberClick(props)
                    recordAlgoliaConversion({
                      userID,
                      event: 'ProfileCall',
                      queryID: urlParamsObj.__queryID || '',
                      objectID: props.data.slug
                    })
                  }}
                  href={`tel: ${props.phone?.number}`}
                >
                  <img
                    className="mr-1.5 w-4 text-white"
                    src={iconPhoneWhite}
                  />
                  <span>{props.phone?.number}</span>
                </a>
              </Button>
            </>
          ) : props.data.primary_cta === null ||
            props.data.primary_cta === 'email' ? (
            <>
              <Button
                className="email-btn"
                flex
                onClick={() => {
                  toggleModal()
                  handleDataLayerInquiryClick(props.data)
                }}
              >
                <a className="flex w-full items-center justify-center">
                  <img
                    className="mr-1.5 w-4"
                    src={iconEnvelopePurple}
                  />
                  Message
                </a>
              </Button>
              <Button className="sticky-footer-call">
                <a
                  className="flex items-center justify-center text-white"
                  id="phone-number-click"
                  onClick={() => {
                    handleDataLayerStickyBarPhoneNumberClick(props)
                    recordAlgoliaConversion({
                      userID,
                      event: 'ProfileCall',
                      queryID: urlParamsObj.__queryID || '',
                      objectID: props.data.slug
                    })
                  }}
                  href={`tel: ${props.phone?.number}`}
                >
                  <img
                    className="mr-1.5 w-4 text-white"
                    src={iconPhoneWhite}
                  />
                  {props.phone?.number}
                </a>
              </Button>
            </>
          ) : props.data.primary_cta === 'message' ||
            props.data.primary_cta === 'email' ? (
            <>
              <Button
                className="email-btn"
                style={{ justifyContent: 'center' }}
                flex
              >
                <a
                  className="flex items-center justify-center text-black"
                  id="phone-number-click"
                  onClick={() => {
                    handleDataLayerStickyBarPhoneNumberClick(props)
                    recordAlgoliaConversion({
                      userID,
                      event: 'ProfileCall',
                      queryID: urlParamsObj.__queryID || '',
                      objectID: props.data.slug
                    })
                  }}
                  href={`tel: ${props.phone?.number}`}
                >
                  <img
                    className="mr-1.5 w-4"
                    src={phonePurple}
                  />
                  {props.phone?.number}
                </a>
              </Button>
              <Button
                className="sticky-footer-call"
                flex
                onClick={() => {
                  toggleModal()
                  handleDataLayerInquiryClick(props.data)
                }}
              >
                <a className="flex w-full items-center justify-center">
                  <img
                    className="mr-1.5 w-4"
                    src={whiteEnvelope}
                  />
                  Message
                </a>
              </Button>
            </>
          ) : (
            (isNil(props.data.verify_insurance_link) ||
              isEmptyString(props.data.verify_insurance_link)) && (
              <Button className="sticky-footer-call">
                <a
                  className="flex items-center justify-center text-white"
                  id="phone-number-click"
                  onClick={() => {
                    handleDataLayerStickyBarPhoneNumberClick(props)
                    recordAlgoliaConversion({
                      userID,
                      event: 'ProfileCall',
                      queryID: urlParamsObj.__queryID || '',
                      objectID: props.data.slug
                    })
                  }}
                  href={`tel: ${props.phone?.number}`}
                >
                  <img
                    src={iconPhoneWhite}
                    className="mr-1.5 w-4 text-white"
                  />
                  {props.phone?.number}
                </a>
              </Button>
            )
          )}
        </div>
      </Style>
      {modal && (
        <Modal
          dashboard={props.data.analyticsDashboard || ''}
          busContact={props.data.businessContact}
          slug={props.data.slug}
          centerId={props.data.id}
          benefitsProvider={props.data?.benefitsProvider}
          benefitsKey={props.data?.benefitsKey}
          listing_template={props.data.listing_template}
          email={props.data.email}
          toggle={toggleModal}
          title={props.data.title}
          trackingID={'Profile Intro'}
          location={props.data.location_label}
          image={props.data.slides[0]}
          setModal={setModal}
          insuranceAccepted={
            !!(
              props.data?.amenities?.includes('Insurance Accepted') ||
              props.data?.price?.includes('Insurance Accepted')
            )
          }
          breadcrumbs={props.breadcrumbs}
        />
      )}
      <ContentModal
        isOpen={isBenefitsModalOpen}
        onClose={closeBenefitsModal}
        headerText="Verification Of Benefits"
      >
        <VoBForm
          benefitsKey={props?.data?.benefitsKey}
          benefitsProvider={props?.data?.benefitsProvider}
          centerTitle={props?.data?.title}
          onClose={closeBenefitsModal}
        />
      </ContentModal>
    </React.Fragment>
  )
}

export default ContactBar
